import { gql } from '@apollo/client';

export const PROPERTY_LIST_QUERY = gql`
  query pagedProperties($pager: PagerInputNew, $filters: PropertyFilterInput) {
    pagedProperties(pager: $pager, filters: $filters) {
      total
      values {
        id
        name
        code
        type
      }
    }
  }
`;

export const PROPERTIES_QUERY = gql`
  query properties($context: String) {
    properties(context: $context) {
      propertyId
      propertyCode
      propertyName
      propertyTypeId
      propertyTypeCode
      readOnly
    }
  }
`;
